import { defineMessages } from 'react-intl'

const scope = `procurify.accounts-payable.components.CreditCardSelect`

export default defineMessages({
  placeholder: {
    id: `${scope}.placeholder`,
    defaultMessage: 'Please select an option',
  },
  ariaLabel: {
    id: `${scope}.ariaLabel`,
    defaultMessage: 'Target credit card',
  },
  noCardsAvailablePlaceholder: {
    id: `${scope}.noCardsAvailablePlaceholder`,
    defaultMessage: 'No credit cards available',
  },
  setupLink: {
    id: `${scope}.setupLink`,
    defaultMessage: 'Create credit card profile',
  },
})
